module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-3-1-13b573dfbba8a752c1a825b35e2ead11.jpg";